import React, { useEffect, useState } from "react";
import styles from "./school-rooms.module.css";
import { Typography } from "antd";
import CustomButton from "../../../../../../../common/custom-button/custom-button";
import { PlusOutlined } from "@ant-design/icons";
import CustomTable from "../../../../../../../common/custom-table/custom-table";
import SVGIcon from "../../../../../../../constants/SVGIcon";
import CustomPopover from "../../../../../../../common/custom-popover/custom-popover";
import { deleteRooms, fetchRooms } from "../../../../../../../services/school_info";
import AddEditRooms from "./components/add-edit-rooms/add-edit-rooms";

const SchoolRooms = () => {
  const [roomList, setRoomList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [editDetails, setEditDetails] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    setPageNo(1);
    getRooms();
  }, []);

  const getRooms = async (tempPage = pageNo, tempPageSize = pageSize) => {
    try {
      setLoading(true);
      const payload = {
        page: tempPage,
        pageSize: tempPageSize,
      };
      const response = await fetchRooms(payload);
      if (response?.data) {
        const data = response?.data?.data?.rooms;
        setRoomList(data);
        setTotalCount(response?.data?.data?.totalRecords);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const handleChangePage = (page, pageSize) => {
    setPageNo(page);
    setPageSize(pageSize);
    getRooms(page, pageSize);
  };

  const handleEditRooms = (data) => {
    setEditDetails(data);
    setOpenDrawer(true);
  };

  const handleOnClose = () => {
    getRooms();
    setOpenDrawer(false);
  };

  const handleDeleteRooms = async (id) => {
    try {
      await deleteRooms(id);
      getRooms();
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddRooms = () => {
    setEditDetails(null);
    setOpenDrawer(true);
  };

  const columns = [
    {
      title: "Room No",
      dataIndex: "room_number",
      key: "room_number",
      sorter: (a, b) => a?.room_number - b?.room_number,
      render: (value) => value || "-",
    },
    {
      title: "Building Name",
      dataIndex: "building_name",
      key: "building_name",
      sorter: (a, b) => a?.building_name?.localeCompare(b?.building_name),
      render: (value) => value || "-",
    },
    {
      title: "Room Type",
      dataIndex: "room_type",
      key: "room_type",
      sorter: (a, b) => a?.room_type?.localeCompare(b?.room_type),
      render: (value) => value || "-",
    },
    {
      title: "Room Capacity",
      dataIndex: "room_capacity",
      key: "room_capacity",
      sorter: (a, b) => a?.room_capacity - b?.room_capacity,
      render: (value) => value || "-",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <div className={styles.actionItemWrapper}>
          <SVGIcon
            name={"edit-icon"}
            width={"20"}
            height={"20"}
            stroke={"#3BB44B"}
            onClick={() => handleEditRooms(record)}
          />
          <CustomPopover
            message="Are you sure you want to delete this room?"
            confirmText="Delete"
            cancelText="Cancel"
            onConfirm={() => handleDeleteRooms(record?.id)}
          >
            <SVGIcon
              name={"delete"}
              width={"20"}
              height={"20"}
              stroke={"rgba(243, 17, 17, 1)"}
            />
          </CustomPopover>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className={styles.titleContainer}>
        <Typography className={styles.tabTitle}>
          Rooms
        </Typography>
        <CustomButton
          title="Add New Room"
          size="large"
          icon={<PlusOutlined />}
          onClick={handleAddRooms}
        />
      </div>

      <div className={styles.tableContainer}>
        <CustomTable
          columns={columns}
          dataSource={roomList}
          loading={loading}
          headerColor="#667085"
          headerBackgroundColor="#F9FAFB"
          total={totalCount}
          pageSize={pageSize}
          currentPage={pageNo}
          handlePageChange={handleChangePage}
        />
      </div>
      <AddEditRooms
        open={openDrawer} 
        onClose={handleOnClose} 
        data={editDetails}
      />
    </div>
  );
};

export default SchoolRooms;